module.exports = __webpack_public_path__ + "facelifting_4_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/facelifting_4_after.jpg
// module id = 1055
// module chunks = 0